import { render } from "./AccountRecoveryPage.vue?vue&type=template&id=375d3446&scoped=true"
import script from "./AccountRecoveryPage.vue?vue&type=script&lang=js"
export * from "./AccountRecoveryPage.vue?vue&type=script&lang=js"

import "./AccountRecoveryPage.vue?vue&type=style&index=0&id=375d3446&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375d3446"]])

export default __exports__